import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { ruleSchema } from '../schemas/rule.schema';

/**
 * Gets all rules in an account
 * @returns Array of rules
 */
export function getRules(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(mapManagementServiceEnvironment.resolve(this).rulesUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(ruleSchema)));
}
